import React, { useMemo } from "react";
import { marked } from "marked";
import DOMPurify from "dompurify";

marked.setOptions({ breaks: true, gfm: true });

// Renders admin-authored basic rich text (markdown -> sanitized HTML).
export function RichText({ md, className = "" }) {
  const html = useMemo(() => {
    if (!md) return "";
    return DOMPurify.sanitize(marked.parse(String(md)), { ADD_ATTR: ["target", "rel"] });
  }, [md]);
  if (!html) return null;
  return <div className={`rich-text ${className}`} dangerouslySetInnerHTML={{ __html: html }} />;
}

export default RichText;
